import { Link } from 'react-router-dom';
import { categories } from '@/mocks/tvShows';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-white">
      <div className="w-full px-4 md:px-6">
        <div className="py-12 md:py-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-movie-line text-lg text-white"></i>
                </div>
                <span className="font-heading text-xl font-bold">被窝网电影</span>
              </div>
              <p className="text-foreground-300 text-sm leading-relaxed">
                被窝网电影提供电视剧全集免费高清在线观看，流畅不缓冲。聚合热门电视剧资源，最新热播剧免费追，无需充值尽享全集。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold mb-4 text-white">电视剧分类</h4>
              <ul className="space-y-2">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-foreground-300 hover:text-primary-400 text-sm transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold mb-4 text-white">关于我们</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/about" className="text-foreground-300 hover:text-primary-400 text-sm transition-colors cursor-pointer">
                    品牌介绍
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-foreground-300 hover:text-primary-400 text-sm transition-colors cursor-pointer">
                    用户口碑
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-foreground-300 hover:text-primary-400 text-sm transition-colors cursor-pointer">
                    联系我们
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold mb-4 text-white">热门推荐</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/article/show-001" className="text-foreground-300 hover:text-primary-400 text-sm transition-colors cursor-pointer">
                    繁花
                  </Link>
                </li>
                <li>
                  <Link to="/article/show-002" className="text-foreground-300 hover:text-primary-400 text-sm transition-colors cursor-pointer">
                    庆余年第二季
                  </Link>
                </li>
                <li>
                  <Link to="/article/show-010" className="text-foreground-300 hover:text-primary-400 text-sm transition-colors cursor-pointer">
                    狂飙
                  </Link>
                </li>
                <li>
                  <Link to="/article/show-003" className="text-foreground-300 hover:text-primary-400 text-sm transition-colors cursor-pointer">
                    黑暗荣耀
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-800 py-6">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-foreground-400 text-xs">
              &copy; {new Date().getFullYear()} 被窝网电影 beiwodianying.com 版权所有
            </p>
            <p className="text-foreground-500 text-xs">
              本站所有资源均来自互联网，仅供交流学习使用
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}